// src/components/MetaData.js
import React from 'react';
import '../styles/MetaData.css';

const MetaData = ({ meta }) => {

    return (
        <div className="meta-info">
            <h2 className='sideBarHeading'>Information</h2>
            <div className="meta-item">
                <strong>Limit:</strong> {meta.limit}
            </div>
            <div className="meta-item">
                <strong>Offset:</strong> {meta.offset}
            </div>
            <div className="meta-item">
                <strong>Returned:</strong> {meta.returned}
            </div>
            <div className="meta-item">
                <strong>Found:</strong> {meta.found}
            </div>
            <div className="meta-item">
                <strong>Total:</strong> {meta.total}
            </div>
        </div>
    );
};

export default MetaData;
